import { useContext, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import {
    getHubspotToken
} from "../../utils/api-lists/hubspot.api";

const HubSpotChat = () => {
  const { user } = useContext(UserContext);
  const email = user?.email;
  useEffect(() => {
    if (!user || !email) return;

    const initHubspotChat = async () => {
      try {
        const token = await getHubspotToken(
          user.firstName,
          user.lastName,
          email
        );

        window.hsConversationsSettings = {
          loadImmediately: false,
          identificationEmail: email,
          identificationToken: token,
        };

        if (window.HubSpotConversations?.widget) {
         
          window.HubSpotConversations.resetAndReloadWidget();
          window.HubSpotConversations.widget.load();
        } else {
          window.hsConversationsOnReady = [
           
            () =>   window.HubSpotConversations.resetAndReloadWidget(),
            ()=>window.HubSpotConversations.widget.load(),
  
            
          ];
        }
      } catch (error) {
        console.error("Error initializing HubSpot chat:", error);
      }
    };
    initHubspotChat();
  }, [user, email]);

  return null;
};

export default HubSpotChat;
